import script from "./MapaCapitulosActividades.vue?vue&type=script&setup=true&lang=js"
export * from "./MapaCapitulosActividades.vue?vue&type=script&setup=true&lang=js"

import "./MapaCapitulosActividades.vue?vue&type=style&index=0&id=d47bde32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d47bde32"]])

export default __exports__